import {UI} from "../../../../../stem-core/src/ui/UIBase";
import {styleRule, StyleSheet} from "../../../../../stem-core/src/ui/Style";
import {registerStyle} from "../../../../../stem-core/src/ui/style/Theme";
import {isSmallScreen} from "../../../../UtilsLib";
import {LinkButton} from "../../../../../core/ui/LinkButton.jsx";


class UserDashboardSectionStyle extends StyleSheet {
    @styleRule
    container = {
        padding: "12px 0",
    };

    @styleRule
    separator = {
        ":not(:last-child)": {
            borderBottom: "0.5px solid #E5E5E5",
            paddingBottom: 24,
        }
    };

    @styleRule
    header = {
        display: "flex",
        justifyContent: "space-between",
        marginBottom: 8,
    };

    @styleRule
    title = {
        fontSize: isSmallScreen() ? this.themeProps.FONT_SIZE_LARGE : 18,
        fontWeight: this.themeProps.FONT_WEIGHT_BOLD,
    };

    @styleRule
    headerTitle = {
        fontSize: isSmallScreen() ? this.themeProps.FONT_SIZE_LARGE : 18,
        fontWeight: this.themeProps.FONT_WEIGHT_BOLD,
        textTransform: "uppercase",
        marginBottom: 8,
    };
}

@registerStyle(UserDashboardSectionStyle)
export class UserDashboardSection extends UI.Element {
    getDefaultOptions(options) {
        return {
            ...super.getDefaultOptions(options),
            action: null,
            secondaryAction: null,
            titleMessage: "",
            headerTitle: "",
            hideSeparator: false,
        };
    }

    extraNodeAttributes(attr) {
        super.extraNodeAttributes(attr);
        if (!this.options.hideSeparator) {
            attr.addClass(this.styleSheet.separator);
        }
    }

    getChildrenToRender() {
        const {styleSheet} = this;
        // TODO @flow why headerTitle and titleMessage?
        const {titleMessage, headerTitle, action, secondaryAction} = this.options;

        return [
            headerTitle && <div className={styleSheet.headerTitle}>{headerTitle}</div>,

            <div className={styleSheet.header}>
                {titleMessage && <div className={styleSheet.title}>{titleMessage}</div>}

                <div style={{flex: 1}}/>

                {secondaryAction && <LinkButton
                    onClick={secondaryAction[1]}
                    style={{marginRight: 12}}
                    label={secondaryAction[0]}
                />}

                {action && <LinkButton
                    onClick={action[1]}
                    label={action[0]}
                />}
            </div>,
            this.render(),
        ];
    }
}
